__turbopack_context__.v({
  "alert": "alert-module-scss-module__ow4TpW__alert",
  "alert__button-icon": "alert-module-scss-module__ow4TpW__alert__button-icon",
  "alert__close-button": "alert-module-scss-module__ow4TpW__alert__close-button",
  "alert__close-button-wrapper": "alert-module-scss-module__ow4TpW__alert__close-button-wrapper",
  "alert__content": "alert-module-scss-module__ow4TpW__alert__content",
  "alert__heading": "alert-module-scss-module__ow4TpW__alert__heading",
  "alert__icon": "alert-module-scss-module__ow4TpW__alert__icon",
  "alert__message": "alert-module-scss-module__ow4TpW__alert__message",
  "alert__variant": "alert-module-scss-module__ow4TpW__alert__variant",
  "alert__variant--error": "alert-module-scss-module__ow4TpW__alert__variant--error",
  "alert__variant--informational": "alert-module-scss-module__ow4TpW__alert__variant--informational",
  "alert__variant--success": "alert-module-scss-module__ow4TpW__alert__variant--success",
});
